
import { NavigateFunction, useNavigate } from 'react-router-dom';
import React, { useContext, useEffect, useState } from "react";

import OtpInput from 'react-otp-input';
import { RoleContext } from "../utils/contexts/RoleContext";
import Toast from 'react-bootstrap/Toast';

import logo from "../../images/signup/logo-image.webp";
import shield from "../../images/signup/signup-shieldimage.webp";
import shield2 from "../../images/signup/signup-shieldimage2.webp";
import { RoleUpdateContext, AlertContext } from "../utils/contexts/RoleContext";
import { getMessaging, getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import { Spinner } from "reactstrap";
import { metaTitle } from "../config/constants";
import { capitalizeFirstLetter } from "../utils/utils";
import { loginDetails } from "../services/authService";
import Layout from '../layouts/Layout';

type Props = {};

const Login: React.FC<Props> = () => {
  let navigate: NavigateFunction = useNavigate();
  // const currentUser = useContext(RoleContext);

  const [loading, setLoading] = useState<boolean>(false);
  const [Email, setEmail] = useState<any>('');
  const [passwordErr, setPasswordErr] = useState("")
  const [emailErr, setEmailErr] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false);

  const [show, setShow] = useState(false);
  const [successValue, setSuccessValue] = useState("");
  const [message, setMessage] = useState("")


  const toast: any = useContext(AlertContext);
  const roleUpdate: any = useContext(RoleUpdateContext);



  const handleSubmit = async (event: any) => {
    console.log('handleSubmit..')
    event.preventDefault()

    if (Email === '') {
      setEmailErr('Email Required*')
      return false
    }
    if (password === '') {
      setPasswordErr('password Required*')
      return false
    }


    const response = await loginDetails(Email, password);
    const responseData = response.data;
    let theme = "success"
    if (response.status == 200) {
      localStorage.setItem('jwtToken', response.data.token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      // localStorage.setItem('role', response.data.role);

      // setJwtToken(response.data.token);
      console.log('setJwtToken', response.data.token)
      setTimeout(() => navigate("/users"), 1000)
    }
    else {
      theme = "danger"
    }
    window.scrollTo(0, 0);
    setShow(true);
    setMessage(responseData.message);
    setSuccessValue(theme);
  }

  const handleToggle = () => {
    setShowPassword(!showPassword)
  }


  return (
    <Layout>
    <div className="signuppage_wrapper">
      <div className="container">
        <div className="col-sm-12 signuppage_section login_page">
          <div className="col-sm-5 signuppage_right_part">
            <form onSubmit={handleSubmit}>
              <div className="loginform_sec">
                <h4>Welcome Back,</h4>
                <h2>Log In!</h2>
                {/* <form> */}
                  <div className="col-sm-12 form-group email">
                    <span>E-mail address</span>
                    <span style={{ color: "red" }}>*</span>
                    <input
                      type="text"
                      className="form-control mt-2"
                      name="phone"
                      placeholder="E-mail address"
                      value={Email}
                      onChange={(e) => { setEmailErr(""); setEmail(e.target.value) }}
                    />
                    {
                      emailErr ?
                        <div >
                          <p style={{ color: "red" }}>{emailErr}</p>
                        </div>
                        :
                        ""
                    }
                  </div>
                  <div className="col-sm-12 form-group mt-2">
                    <div className="d-flex justify-content-between">
                      <div>
                        <span>Password</span>
                        <span style={{ color: "red" }}>*</span>
                      </div>
                    </div>
                    <div className="position-relative  otp-animation">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control mt-2"
                        name="lname"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => {
                          setPasswordErr("");
                          setPassword(e.target.value)
                        }}
                      // onKeyDown={(e) => {
                      //   if (e.key === "Enter")
                      //     handleSubmit(e);
                      // }}
                      />
                      <div
                        className="position-absolute clickable"
                        style={{
                          right: "20px",
                          top: '10px'
                        }}
                      >
                        <i
                          className={`bi ${showPassword ? "bi-eye" : "bi-eye-slash"} fs-5 text-secondary`}
                          onClick={() => setShowPassword(!showPassword)}
                        />
                      </div>
                    </div>
                    {
                      passwordErr ?
                        <div >
                          <p style={{ color: "red" }}>{passwordErr}</p>

                        </div> : ""
                    }

                  </div>
                  <div className="col-sm-12 forgetpass_sec justify-content-end">
                    {/* <div className="round">
                      <span onClick={() => navigate("/register")} className="clickable">Not Registered?</span>
                    </div> */}
                    <a onClick={() => navigate(`/register`)} className="textgreen clickable">Not Registered?</a>
                  </div>
                  <div className="col-sm-12 signup_btn">
                    <button type="button" id="form_cancel" onClick={() => navigate(-1)}>
                      Cancel
                    </button>
                    <button type="submit" id="form_signup">
                      Login
                      {loading &&
                        <span className="ms-2">
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        </span>
                      }
                    </button>
                  </div>
                  {/* {
                    err ?
                      <div >
                        <p style={{ color: "red" }}>{err}</p>

                      </div> : ""
                  } */}
                {/* </form> */}
              </div>
            </form>
          </div>
        </div>
        {/* <div className="col-sm-12 termsprivacy_section">
          <p>
            By login you agree to our <a href="#">Terms of Service</a> and{" "}
            <a href="#">Privacy Policy.</a>
          </p>
        </div> */}
      </div >


      {show &&
        <Toast className={successValue === "success" ? "float-start end-0 position-absolute show bg-success z-3" : "float-start end-0 position-absolute show bg-danger z-3"} style={{ top: "0px" }}>
          <Toast.Header className={`show ${successValue === "success" ? "bg-success" : "bg-danger"}`}>
            <strong className="me-auto text-white">Success Message</strong>
          </Toast.Header>
          <div aria-live="polite" aria-atomic="true" className="d-flex justify-content-center align-items-center w-100 mb-10 text-white bg-transparent">
            <div className="fade toast show  bg-transparent" role="alert" aria-live="assertive" aria-atomic="true">
              <div className="fade toast show bg-transparent p-4 text-white">
                {message}
              </div>
            </div>
          </div>
        </Toast>
      }
    </div >
    </Layout>
  );
};

export default Login;